import { JWTService } from "@/shared/services/jwt";
import axios from "axios";
import gButton from "@/components/g-button/g-button.vue";
import { required, minLength, helpers } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import gValidators from "@/shared/custom/validators/g-validators";


const name = 'MeuPerfil'
export default {
  name,

  components: {
    'g-button': gButton
   },

  props: { },

  setup(){
    return {
      v$: useVuelidate()
    }
  },

  mounted () {
    axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + 'meuperfil',
        headers: {'Authorization': `Bearer ${JWTService.GetToken()}`}
      }).then(res => this.dadosUsuario = res.data.data);
  },

  updated () { },

  data () {
    return {
        tipoA: 'password',
        tipoB: 'password',
        tipoC: 'password',
        isActive: false,
        disablednome: true,
        disabledtelefone: true,
        popupTrocarSenha: false,
        dadosUsuario: {},
        senhaAtual: '',
        senhaNova: '',
        submit: false,
        senhaNovaConfirmacao: '',
        edicoes: {
          inputNome: true
        },
     }
  },

  validations() {
    return {
      senhaAtual:{
        required: helpers.withMessage('O campo de Senha Atual é obrigatório', required)
      },
      senhaNova:{
        required: helpers.withMessage('O campo de Nova Senha é obrigatório', required),
        minLength: helpers.withMessage( `Sua senha precisa ter no mínimo 6 caracteres`, minLength(6)),
        contemEspeciais: helpers.withMessage( `Sua senha precisa ter caracteres especiais`, gValidators.contemEspeciais),
        contemMinusculas: helpers.withMessage( `Sua senha precisa ter alguma letra minúscula`, gValidators.contemMinusculas),
        contemMaiuscula: helpers.withMessage( `Sua senha precisa ter alguma letra maiúscula`, gValidators.contemMaiuscula),
        contemNumero: helpers.withMessage( `Sua senha precisa ter números`, gValidators.contemNumero),
      },
      senhaNovaConfirmacao:{
        required: helpers.withMessage('O campo de confirmação da Nova Senha é obrigatório', required),
      },
    }
  },

  methods: {
    mostrarSenhaA(){
      if(this.tipoA === 'password'){
        this.tipoA = 'text'
      }
      else{
        this.tipoA = 'password'
      }
    },

    mostrarSenhaB(){
      if(this.tipoB === 'password'){
        this.tipoB = 'text'
      }
      else{
        this.tipoB = 'password'
      }
    },

    mostrarSenhaC(){
      if(this.tipoC === 'password'){
        this.tipoC = 'text'
      }
      else{
        this.tipoC = 'password'
      }
    },
    
    desativarnome(){
      this.disablednome = !this.disablednome
      this.isActive =! this.isActive
    },

    desativartelefone(){
      this.disabledtelefone = !this.disabledtelefone
      this.isActive =! this.isActive
    },
    isDisabled(){
      return this.inputNome == false
    },
    habilitaEdicao (elemento) {
      this.edicoes[elemento] = !this.edicoes[elemento]
    },
    salvaDados (){
      this.disablednome = true
      this.disabledtelefone = true
      axios({
        method: 'put',
        data: this.dadosUsuario,
        url: process.env.VUE_APP_WEB_API + 'meuperfil',
      })
        .then(() => {
          this.$toast.add({severity:'success', summary: 'Dados alterados com sucesso', detail:'Seus dados foram alterados', life: 5000});
        })
        .catch(() => {
          this.$toast.add({severity:'error', summary: 'Erro ao atualizar dados', detail:'Seus dados não foram alterados', life: 5000});
        });
    },

    abrirPopupTrocarSenha(){
      this.popupTrocarSenha = true;
    },

    fecharpopup(){
      this.popupTrocarSenha = false;
    },

    alterarSenha () {
     
      this.submit = true
    
      if(this.v$.$invalid === false){

      if (this.senhaNova !== this.senhaNovaConfirmacao){
        this.$toast.add({severity:'warn', group:'gama', summary: 'As senhas não iguais', detail:'As senhas não são iguais', life: 5000});
        return
      }
      axios({
        method: 'put',
        data: {
          senhaAtual: this.senhaAtual,
          senhaNova: this.senhaNova,
          login: this.dadosUsuario.login
        },
        url: process.env.VUE_APP_WEB_API + 'meuperfil/trocar-senha',
      })
        .then((res) => {
          if(res.data.code == 200){
            this.$toast.add({severity:'success', summary: 'Senha alterada com sucesso', detail:'Senha alterada com sucesso', life: 5000});
            this.popupTrocarSenha = false;
            this.senhaAtual= ''
            this.senhaNova= ''
            this.senhaNovaConfirmacao= ''
          }
          else{
            this.$toast.add({severity:'error', summary: 'Erro ao alterar senha', detail:res.data.mensagem, life: 5000});

          }
          axios({
            method: 'get',
            url: process.env.VUE_APP_WEB_API + 'meuperfil',
            headers: {'Authorization': `Bearer ${JWTService.GetToken()}`}
          }).then(res => this.dadosUsuario = res.data.data);

        })
        .catch(() => {
          this.$toast.add({severity:'error', summary: 'Erro ao alterar senha', detail:'Erro ao alterar senha', life: 5000});
        });
      } else {
        this.v$.$silentErrors.forEach(erro =>{
         
          this.$toast.add({severity:'error', summary: 'ERRO', detail:erro.$message,  life: 5000})
          
      })
      }
    },


  },

  computed: { },

};